import Box from "@mui/material/Box";
import { productListStyle } from "./CouponStyles";
import { ProductItem } from "./ProductItem";
import { CartItem } from "@ecommerce/store";

export const ProductList: React.FC<{ cartItems: CartItem[] }> = ({ cartItems }) => (
  <Box sx={productListStyle}>
    {cartItems.map((item, index) => (
      <ProductItem key={index} item={item} />
    ))}
  </Box>
);














